<template>
    <tfoot>
        <slot />
    </tfoot>
</template>

<script setup>
defineOptions({
    name: 'ZenGridFooter',
})
</script>
